import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";

function AddressRow({
  equal,
  noMargin,
  noColumns,
  secondIcon,
  secondBigger,
  firstChildren,
  secondChildren
}) {
  const [firstClass, setFirstClass] = useState();
  const [secondClass, setSecondClass] = useState();
  const [firstDimensions, setFirstDimensions] = useState();
  const [secondDimensions, setSecondDimensions] = useState();
  useEffect(() => {
    const canSet = !noMargin && !noColumns;
    setFirstClass(
      canSet && {
        className: `address-form-first-column${
          equal || secondBigger ? "" : "-special"
        }`
      }
    );
    setSecondClass(
      canSet && {
        className: `center address-form-second-column${
          equal || secondBigger ? "" : "-special"
        }`
      }
    );
    setFirstDimensions(
      noColumns
        ? {
            span: equal ? 11 : secondBigger ? 8 : secondIcon ? 21 : 13
          }
        : {
            xxl: equal ? 9 : secondBigger ? 7 : secondIcon ? 15 : 10,
            sm: equal ? 13 : secondBigger ? 10 : secondIcon ? 21 : 14
          }
    );
    setSecondDimensions(
      noColumns
        ? {
            span: equal ? 11 : secondBigger ? 14 : secondIcon ? 1 : 9,
            offset: 2
          }
        : {
            xxl: equal ? 7 : secondBigger ? 9 : secondIcon ? 1 : 6,
            sm: equal ? 8 : secondBigger ? 11 : secondIcon ? 1 : 7
          }
    );
  }, [equal, secondIcon, secondBigger, noMargin, noColumns]);

  return (
    <Row type="flex" align={noColumns ? "middle" : "top"}>
      <Col {...firstDimensions} {...firstClass}>
        {firstChildren}
      </Col>
      <Col {...secondDimensions} {...secondClass}>
        {secondChildren}
      </Col>
    </Row>
  );
}

export default AddressRow;
